'use client';
import { useTranslations } from 'next-intl';

/**
 * @deprecated use `useTranslations('participating.legacy')` from 'next-intl' wherever possible.
 */
export const useTranslate = () => useTranslations('participating.legacy');
